export const loadExcelJs = async () => {
  const module = await import(/* webpackChunkName: "excel-engine" */ "exceljs");
  return module.default || module;
};
